import { Button, Card, Image, Modal, Space, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import StoryService from "../../../../service/StoryService";
import AddStory from "./AddStory";
import EditStory from "./EditStory";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import { API_IMG_URL } from "../../../../configs/AppConfig";

const { confirm } = Modal;

const Story = () => {
  const [openAdd, setOpenAdd] = useState({
    open: false,
    storyId: "",
  });

  const [loading, setLoading] = useState(false);

  const [openEdit, setOpenEdit] = useState({
    open: false,
    storyId: "",
  });
  const [Story, setStory] = useState<any>([]);
  const [newStoryId, setNewStoryId] = useState("");

  const showDrawerAdd = async () => {
    setOpenAdd({
      open: true,
      storyId: "",
    });
  };

  const showDrawerEdit = (record: any) => {
    setOpenEdit({ open: true, storyId: record?._id });
  };

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      const result = await StoryService.fetchFilter(1);

      setStory({
        data: result?.data?.stories,
        total: result?.data?.total,
      });
      setLoading(false);
    };
    fetchOrders();
  }, []);

  const columns = [
    // {
    //   title: "品名",
    //   dataIndex: "key",
    //   key: "key",
    // },
    {
      title: "缩略图kz",
      dataIndex: "thumbnail_img_kk",
      key: "thumbnail_img_kk",
      width: "20%",

      render: (text: string, record: any) => (
        <>
          <Image
            width={100}
            src={API_IMG_URL + record?.thumbnail_img_kk?.img}
          />
        </>
      ),
    },
    {
      title: "缩略图ru",
      dataIndex: "thumbnail_img_ru",
      key: "thumbnail_img_ru",
      width: "20%",
      render: (text: string, record: any) => (
        <>
          <Image
            width={100}
            src={API_IMG_URL + record?.thumbnail_img_ru?.img}
          />
        </>
      ),
    },
    {
      title: "缩略图cn",
      dataIndex: "thumbnail_img_zh",
      key: "thumbnail_img_zh",
      width: "20%",
      render: (text: string, record: any) => (
        <>
          <Image
            width={100}
            src={API_IMG_URL + record?.thumbnail_img_zh?.img}
          />
        </>
      ),
    },

    {
      title: "更多",
      key: "action",

      render: (text: string, record: any) => (
        <>
          <Space size="middle">
            <Button
              danger
              type="primary"
              onClick={() => {
                deleteStoryConfirm(record?._id);
              }}
            >
              删除
            </Button>
          </Space>
          <Space size="middle">
            <Button
              type="primary"
              onClick={() => {
                showDrawerEdit(record);
              }}
            >
              修改
            </Button>
          </Space>
        </>
      ),
    },
  ];

  const pageChangeHandle = async (page: number, pageSize: number) => {
    setLoading(true);
    const res = await StoryService.fetchFilter(page);
    setStory({
      data: res.data.stories,
      total: res.data.total,
    });
    setLoading(false);
  };

  const deleteStory = async (id: string) => {
    await StoryService.delete(id);
    window.location.reload();
  };

  const deleteStoryConfirm = (id: string) => {
    confirm({
      icon: <ExclamationCircleOutlined />,
      title: "确认删除？",
      okText: "确认",
      cancelText: "取消",
      onOk() {
        deleteStory(id);
      },
    });
  };

  return (
    <Card>
      <Button
        onClick={showDrawerAdd}
        style={{
          marginTop: 20,
          marginBottom: 20,
          marginLeft: 20,
          backgroundColor: "green",
        }}
        type="primary"
      >
        添加
      </Button>
      <Table
        loading={loading}
        dataSource={Story.data}
        columns={columns}
        rowKey="_id"
        pagination={{
          pageSize: 12,
          total: Story.total,
          onChange: pageChangeHandle,
        }}
      />
      {openAdd && <AddStory openData={openAdd} setOpenData={setOpenAdd} />}
      {openEdit.open && (
        <EditStory openData={openEdit} setOpenData={setOpenEdit} />
      )}
    </Card>
  );
};

export default Story;
